import React from "react";
import CopyrightIcon from '@mui/icons-material/Copyright';
import LogoImage from '../../../assets/Logo.png';

const Copyright = ()=>{
    return(
        <div className="copyrightContainer">
            <small className="copyright">
                <span>
                    <img src={LogoImage} alt="logo"/>
                </span>
                <span>
                    <CopyrightIcon /> 
                </span>
                <span>
                    {new Date().getFullYear()} 
                </span>
                <span>
                    Oasys
                </span>
                <span>
                    All rights reserved.
                </span>
            </small>
        </div>
    )
}

export default Copyright;